import axios from "axios";
import { setLogout } from "state";
import { persistor, store } from "store";

let handlingSessionExpiry = false;

/** Paths that may legitimately return 401 (bad credentials, etc.) — do not force logout. */
const AUTH_URL_MARKERS = [
	"/accounts/authenticate",
	"/accounts/login",
	"/accounts/forgot",
	"/accounts/reset",
	"/accounts/password",
	"/password-reset",
	"/forgot-password",
];

const isAuthRequest = (config) => {
	const url = String(config?.url || "");
	const full = String(config?.baseURL || "") + url;
	const target = `${full} ${url}`.toLowerCase();
	return AUTH_URL_MARKERS.some((marker) => target.includes(marker));
};

const forceLogoutToLogin = async () => {
	if (handlingSessionExpiry) return;
	handlingSessionExpiry = true;

	try {
		store.dispatch(setLogout());
		delete axios.defaults.headers.common.Authorization;
		await persistor.flush();
	} catch (_) {
		// Still redirect even if persist flush fails.
	}

	const onLoginPage = window.location.pathname.startsWith("/login");
	if (onLoginPage) {
		handlingSessionExpiry = false;
		return;
	}

	window.location.assign("/login?session=expired");
};

/**
 * Global axios response interceptor: on 401 (expired/invalid session),
 * clear auth state and send the user to login.
 * Covers all default-axios call sites (hooks, scenes, tables) without per-hook wiring.
 */
export const setupAxiosAuthInterceptor = () => {
	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			const status = error?.response?.status;
			if (status === 401 && !isAuthRequest(error?.config)) {
				forceLogoutToLogin();
			}
			return Promise.reject(error);
		}
	);
};
